export const BLUR_FADE_DELAY = 0.15;

export type HeaderItem = {
  trigger?: string;
  href?: string;
  label?: string;
  content?: {
    main?: {
      href: string;
      icon: React.ReactNode;
      title: string;
      description: string;
    };
    items: Array<{
      href: string;
      title: string;
      description: string;
    }>;
  };
};

// Type guard to check if item has content
export const hasContent = (item: HeaderItem): item is HeaderItem & { content: NonNullable<HeaderItem['content']> } => {
  return item.content !== undefined;
};

// The Elementix app still lives on app.elementix.ai until the Clerk
// primary-domain cutover. Until then, login/app links must point there or
// Clerk auth breaks (the publishable key's Frontend API is clerk.elementix.ai
// and app.elementix.com isn't a registered Clerk origin yet). At cutover, set
// NEXT_PUBLIC_APP_URL=https://app.elementix.com and rebuild (NEXT_PUBLIC_* is
// build-inlined).
export const APP_URL = process.env.NEXT_PUBLIC_APP_URL || "https://app.elementix.ai";

export const siteConfig = {
  name: "Elementix",
  description: "Borrower intelligence platform for lenders",
  url: "https://elementix.com",
  keywords: ["real estate analytics","real estate data","lender analytics","commercial real estate lending data"],
  header: [
    {
      label: "FAQ",
      href: "/faq",
    },
    {
      label: "Login",
      href: `${APP_URL}/`,
    },
  ] as HeaderItem[],
  meetingLink: "/contact"
};

export type SiteConfig = typeof siteConfig;
